import { Component, OnInit } from '@angular/core';
import { Route, FlightLevelType, MaxflightlevelUnit } from '@app/flight-planning/flight-plan-constant';
import { FlightPlanService } from '@app/flight-planning/route-plan/services/flight-plan.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-dest-route',
    templateUrl: './dest-route.component.html',
    styleUrls: ['./dest-route.component.scss'],
    standalone: false
})
export class DestRouteComponent implements OnInit {
  private route = new Route();
  public flightLevelType = FlightLevelType;
  public maxflightlevelUnit = MaxflightlevelUnit;
  public disableFlightlevelSelection: boolean = false;
  public crusieProfile = [];
  public disableOption: boolean = false;
  public flightPlanSubscription:Subscription
  constructor(public flightPlanService: FlightPlanService) { }

  public ngOnInit() {
    this.fetchDataOfRoute();
    // setTimeout(() => {
      this.routeToggle();
    // }, 100);
  }
  public fetchDataOfRoute()
  {
    this.flightPlanSubscription=  this.flightPlanService.getRouteDataObservable().subscribe((routeData:any)=>{
      if(routeData)
      {
        this.flightPlanService.route=routeData;
        this.flightPlanService.route.flightLevelType == "ExactFlightLevelSpecification"
        ? (this.disableFlightlevelSelection = true)
        : (this.disableFlightlevelSelection = false);
        this.routeToggle();
      }
      else
      {
        this.route = this.flightPlanService.route;
      }
    })
  }
  public openAccordian() {
    this.flightPlanService.accordionSwitch('destroute');
  }
  public toggle() {
    this.flightPlanService.route.flightLevelType == "ExactFlightLevelSpecification"
      ? (this.disableFlightlevelSelection = true)
      : (this.disableFlightlevelSelection = false);
  }
  public getFormatedProfile(profileName: string) {
    switch (profileName.toLowerCase()) {
      case "long range cruise":
        return "LRC";
      case "max spd cruise":
        return "Max";
      case "max speed cruise":
        return "MAX";
      default:
        return profileName.indexOf("Mach") >= 0 ? profileName.replace("Mach 0", "M") : profileName;
    }
  }
  public routeToggle() {
    this.flightPlanService.route.routeOption == "manual"
      ? (this.disableOption = true)
      : (this.disableOption = false);

      // this.flightPlanService.route.routeOption == "manual"?
      // this.flightPlanService.route.ATCDestRoute = '':
      // this.flightPlanService.route.ATCDestRoute
  }
  public ngOnDestroy() {
    this.flightPlanSubscription.unsubscribe();
  }
}
